import React, { useState } from 'react'
import ReportIcon from '@mui/icons-material/Report';
import CategoryIcon from '@mui/icons-material/Category';import {  DateRange, Label, Sell, Sensors } from '@mui/icons-material'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SearchNot from '../../images/searchNot.png'
import EditComment from '../editCattleComment'
import { useGlobalContext } from '../Context'
import DeleteComm from '../deleteComment'
import EmptyReturn from '../EmptyReturn';
const moment=require('moment-jalaali')

const CommentList = ({flag,types}) => {
    const [comId,setComId]=useState('')
    const [selected,setSelected]=useState('')
    const {currentTheme}=useSelector(state=>state.p.admin)
    const {currentPens}=useSelector(state=>state.pens)
    const [iindex,setIindex]=useState()
    const {currentComments}=useSelector(state=>state.comments)
    const {isModalEditCommentOpen,openEditModallComment,openD,opens}=useGlobalContext()
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%',direction:'rtl'}}>
     {
        currentComments?.length?currentComments.map((item,index)=>{
            const {createAt}=item;
                    const birth=createAt?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
            return <div data-aos="zoom-out-down"  key={index} className='  col-sm-12 col-md-6 col-lg-3 col-xl-3   gap-3'>
                <div  className='ThemeCard' >
            <div className='col-lg-12'>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                <span>موضوع :</span>
                <span>{item?.title}</span>
            </div>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <CategoryIcon/>
                </span>
                    </div></div>
                <span>دسته :</span>
                <span>{item?.cattleCommentTypeTitle||item?.penCommentTypeTitle||item?.farmCommentTypeTitle}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>تاریخ ایجاد :</span>
                <span>{pbirth}</span>
            </div>
            {flag!=='farm'&&flag!=='cattle'&&<div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Label/>
                </span>
                    </div></div>
                    {flag=='cattles'&&<span style={{width:'110px'}}>
                    <div className={`itemCattleFilter`} style={{border:'none',backgroundColor:'transparent'}} key={index}>
        <div className='d-flex' style={{gap:'7px'}}>
          <div className='d-flex align-items-center' style={{gap:'7px'}}>  <Sell color='success' fontSize='small'/>  {item?.necklaceNumber?item?.necklaceNumber:'〰'}</div>
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/> {item?.bodyNumber?item?.bodyNumber:'---'}</div>
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/>  {item?.earTagNumber?item?.earTagNumber:'---'}</div>
        </div>
        
      </div>
                      </span>}
                      {flag=='pens'&&<span>
                      {
                        currentPens.find(type=>{
                        
                        return type.id==item.penId
                      })?.name}
                        </span>}
            </div>}
            
            <div style={{display:'flex',gap:'5px',fontSize:'12px',width:'100%'}}>
               <div onClick={()=>{setIindex(index);setSelected(item);openEditModallComment()}} className="EditMOdalBtnForm" style={{width:'100%'}}>جزئیات</div>
               <div style={{width:'100%'}} onClick={()=>{openD();setComId(item.id)}}  className="EditMOdalBtnForm"> حذف </div>
           </div>
            
            
            </div>
            
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
    
     {currentTheme&&isModalEditCommentOpen&&<EditComment iindex={iindex} types={types} selected={selected} flag={flag}/>}
    {currentTheme&&opens&&<DeleteComm penr={comId} type={flag}/>}
    </Container>
  )
}

export default CommentList
